(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('httpInterceptor', httpInterceptor);

    function httpInterceptor($httpParamSerializer, $location, $q, $rootScope, apiUrl, blockUI) {
        var service = {
            response: response,
            request: request,
            responseError: responseError
        };

        function response(data) {
            return data;
        }

        function responseError(error) {

            blockUI.stop();
            
            switch (error.status) {
                case 406:
                    toastr.warning($rootScope.translate.pleaseSetNo);
                    $location.path('/').search('menu', 31);
                    break;
                case 404:
                    toastr.warning(error.data);
                    break;
                case 403:
                    toastr.warning($rootScope.translate.canNotAccess);
                    $location.path('/').search('menu', 31);
                    break;
                case 401:
                    if (sessionStorage.getItem('token')) {
                        if ($rootScope.translate) {
                            toastr.warning($rootScope.translate.tokenIsTimeout);
                        }
                    }
                    removeSsoInfo();
                    $location.path('/login').search({});
                    break;
                case 400:
                    toastr.warning(error.data.message);
                    break;
                case 303:
                    var isConfirm = confirm(error.data);
                    if (isConfirm) {
                        if (sessionStorage.getItem('token')) {
                            $location.path('/').search('menu', 1);
                        } else {
                            $location.path('/login').search({});
                        }
                    } else {
                        return $q.resolve(error);
                    }
                    break;

                case -1:

                    // 在 IOS APP 中停留一段時間
                    // 在按上一頁面就會產生 -1 的錯誤訊息
                    // 但此 error 不包含任何 data / message 資訊
                    // 所以就先這樣 避免進入 default 跳出錯誤訊息

                    break;

                default:

                    // post error message to server
                    var status = '', data = '', message = '';
                    if (error) {
                        if (error.statu) { 
                            status = error.status;
                        }
                        if (error.data) {
                            data = error.data;
                            if (error.data.message) {
                                message = error.data.message;
                            }
                        }
                    }
                    
                    var errorLog = `[httpInterceptor] status: ${error.status}, data: ${error.data}, message: ${message}`;
                    postException(errorLog, apiUrl);

                    showSystemError();
                    break;
            }
            return $q.reject(error);
        }

        function request(config) {
            var contentType = _.get(config.headers, 'Content-Type');
            if (!_.startsWith(contentType, 'application/json')) {
                config.headers = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
                config.transformRequest = function (data) {
                    return $httpParamSerializer(data);
                };
            }


            // config.headers["Accept-Language"] = sessionStorage.getItem("userLang");

            // if (sessionStorage.getItem('langCode')) {
            //     config.headers.LangCode = sessionStorage.getItem('langCode');
            // } else {
            //     config.headers.LangCode = getDefaultLangCode();
            //     sessionStorage.setItem('langCode', getDefaultLangCode());
            // }

            if (sessionStorage.getItem('langCode')) {
                config.headers.LangCode = sessionStorage.getItem('langCode');
                config.headers["Accept-Language"] = sessionStorage.getItem('userLang');
            } else {

                getDefaultUserLang(apiUrl.tsApi, navigator.systemLanguage).done(function (data) {

                    var userLang = data;
                    var langCode = getLangCode(userLang);
                    config.headers.LangCode = langCode;
                    sessionStorage.setItem('langCode', langCode);
                    
                });

            }



            return config;
        }

        return service;
    }
})();